import React from 'react';

const TrackingButton = ({
  children, 
  onClick, 
  trackingName, 
  trackingCategory = 'Button Clicks',
  trackingValue = null,
  href,
  target,
  rel,
  className,
  ...props 
}) => {
  const handleClick = (e) => {
    // Call the original onClick if provided
    if (onClick) {
      onClick(e);
    }
  };

  // Render as link if href is provided
  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        onClick={handleClick}
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Render as button
  return (
    <button
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

export default TrackingButton;